import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDpadT = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 51,
	height: 51,
	viewBox: "0 0 51 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			filter: "url(#filter0_d_207_27189)",
			children: [/* @__PURE__ */ _jsx("circle", {
				cx: 25.5,
				cy: 25.5,
				r: 21.5,
				fill: "url(#paint0_linear_207_27189)",
				fillOpacity: .5,
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 25.5,
				cy: 25.5,
				r: 21,
				stroke: "#00FF33",
				shapeRendering: "crispEdges"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_207_27189",
			x: 0,
			y: 0,
			width: 51,
			height: 51,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_207_27189"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_207_27189",
					result: "shape"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_207_27189",
			x1: 25.5,
			y1: 3.99999,
			x2: 25.5,
			y2: 54.9456,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FBF7F7" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .482201,
					stopColor: "#D3D3D3"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#828181"
				})
			]
		})] })
	]
});
export default SvgDpadT;
